import './FilterGroup.scss';

export const FilterGroup = ({ 
    options = [],
    multiselect = false,
    enableNegatives = false,
    columns = 3,
    renderOption = o => o,
    onChange = () => {},
    value
}) => {
    const isActive = (opt) => {
        if (enableNegatives) {
            return value?.positive?.includes(opt);
        } else if(multiselect) {
            return value?.includes(opt);
        } else {
            return value === opt;
        }
    };

    const isNegative = (opt) => {
        if (!enableNegatives) return false;
        
        return value?.negative?.includes(opt);
    }

    const handleOptionClick = (opt) => {
        if (enableNegatives) {
            if (isActive(opt)) {
                onChange({
                    positive: value?.positive.filter(o => o !== opt),
                    negative: [
                        ...(value?.negative || []),
                        opt
                    ]
                })
            } else if (isNegative(opt)) {
                onChange({
                    positive: value?.positive,
                    negative: value?.negative.filter(o => o !== opt)
                })
            } else {
                onChange({
                    positive: [
                        ...(value?.positive || []),
                        opt
                    ],
                    negative: value?.negative
                })
            }
        } else if (multiselect) {
            onChange(
                value && value.includes(opt) ? 
                    value.filter(o => o !== opt) 
                : 
                    [...(value || []), opt]
            )
        } else {
            onChange(value === opt ? null : opt);
        }
    };

    return (
        <div
            className="FilterGroup"
            style={{
                gridTemplateColumns: `repeat(${columns}, 1fr)`
            }}
        >
            {options.map(opt => (
                <button
                    key={opt}
                    className={`
                        ${isActive(opt) ? 'active' : ''}
                        ${isNegative(opt) ? 'negative' : ''}
                    `}
                    onClick={() => handleOptionClick(opt)}
                >
                    {renderOption(opt)}
                </button>
            ))}
        </div>
    );
};